import React from 'react'
import ApiUrl from '../../../configTools/apiUrl'

const ImagePicker = ({Images,SetImages}) => {

  const showPreview = (e) =>{
    if(Images.length > 4){
      return;
    }
    if(e.target.files && e.target.files[0]){
      if(e.target.files[0].size > 1097152){
        alert("File is too big!");
        return;
      };
        let imageFile = e.target.files[0];
        const formData = new FormData();
        formData.append("file",imageFile);
        fetch(ApiUrl.API_URL_File, {
          method: 'POST',
          body: formData
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
              let imageList = [];
              for (let index = 0; index < Images.length; index++) {
                const element = Images[index];
                imageList.push(element);
              }
              imageList.push(data.url);
              SetImages(imageList);
            }
            else{
              console.log(data.responce);
            }
        });
    }
  }

  const remove_image = (e)=>{
    let imageList = [];
    for (let index = 0; index < Images.length; index++) {
        if(index !== e){
            const element = Images[index];
            imageList.push(element);
        }
    }
    SetImages(imageList);
  }
  return (
    <div className='admin_forms_multirow'>
        <div className='admin_col_33'>
        <label style={{cursor:"pointer"}}>
            <div style={{
                width: "100%",
                paddingTop: "80%",
                borderRadius: "3px",
                border: "2px dashed black",
                position: "relative"
            }}>
                <div style={{display:"flex", position:"absolute", top:"0", left:"0", bottom:"0", width:"100%", justifyContent:"center",alignItems:"center"}}>
                    <p>Add</p>
                </div>
                <input type="file" accept='image/*' style={{display:"none"}} onChange={showPreview}/>
            </div>
        </label>
        </div>
        {
        Images.map((image,index)=>{
            return(
            <div className='admin_col_33' key={index}>
                <label style={{cursor:"pointer"}}>
                        <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "10px",
                        position: "relative",
                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'
                        }}>
                        <div className='product_image_remove' onClick={()=>{remove_image(index)}}>X</div>
                        </div>
                </label>
            </div>
            )
        })
        }
    </div>
  )
}

export default ImagePicker
